<template>
  <div id="chapters">
    <h4><span v-if="selectBook">{{selectBook.title}} > </span>章の編集</h4>

    <section>
      <el-form label-width="100px" :model="newChapter" style="width:100%">
        <el-form-item label="章タイトル">
          <el-input placeholder="章タイトル" v-model="newChapter.title"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="save(newChapter)">追加</el-button>
        </el-form-item>
      </el-form>
    </section>

    <section>
      <el-table
        :data="$store.state.Chapters.chapters"
        style="width:100%">
        <el-table-column
          label="順序"
          width="100">
          <template slot-scope="scope">
            <el-input v-if="current.id === scope.row.id" type="number" min="1" v-model="current.number" />
            <span v-else>{{scope.row.number}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="章タイトル">
          <template slot-scope="scope">
            <el-input v-if="current.id === scope.row.id" type="text" v-model="current.title" />
            <span v-else>{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="220">
          <template slot-scope="scope">
            <el-button v-if="current.id === scope.row.id && !equalObject(current, scope.row)"
              size="mini"
              type="primary"
              @click="save(current)">保存</el-button>
            <el-button v-if="current.id === scope.row.id && equalObject(current, scope.row)"
              size="mini"
              @click="cancel()">キャンセル</el-button>
            <el-button v-if="current.id !== scope.row.id"
              size="mini"
              @click="edit(scope.row)">編集</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="remove(scope.row)">削除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'chapters',
  data () {
    return {
      newChapter: {number: 0, title: ''},
      current: {number: 0, title: ''}
    }
  },
  created () {
    console.log('chapters::created')
    this.fetchChapters()
  },
  computed: {
    ...mapGetters('Books', ['selectBook'])
  },
  methods: {
    fetchChapters () {
      this.$store.dispatch('Chapters/fetch', {'book_id': this.$route.params.id})
    },
    edit (chaptar) {
      this.current = this.cloneObject(chaptar)
    },
    cancel () {
      this.current = {number: 0, title: ''}
    },
    save (chapter) {
      if (chapter.title === '') {
        this.errorMessage('タイトルが入力されていません')
        return
      }

      var action = ''
      if (!chapter.id) {
        action = 'insert'
        chapter.book_id = this.$route.params.id
      } else {
        action = 'update'
      }

      var self = this
      this.$store.dispatch('Chapters/' + action, {'chapter': chapter}).then(function (response) {
        if (!response.result) {
          self.errorMessage(response.message)
        } else {
          self.fetchChapters()
          self.successMessage(response.message)
        }

        self._clearEditor()
      }).catch(function (error) {
        self.$message({
          type: 'error',
          message: error.message,
          duration: 5000
        })
        self._clearEditor()
      })
    },
    remove (chaptar) {
      this.$confirm('章「' + chaptar.title + '」を削除します。よろしいですか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        var self = this
        this.$store.dispatch('Chapters/delete', {'id': chaptar.id}).then(function (response) {
          self.successMessage(response.message)
        })
      }).catch(() => {})
    },
    _clearEditor () {
      this.newChapter = {number: 0, title: ''}
      this.current = {number: 0, title: ''}
    }
  }
}
</script>

<style>
.el-form-item:first-child{
  margin-bottom:8px;
}
</style>



// WEBPACK FOOTER //
// src/components/04-pages/Chapters.vue